import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './revenueOutlook.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    statementDate: '2026-07-31',
    tags: [],
    includeClosed: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;
    if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);
      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="ro-box">
      <h2 className="ro-title">Parameters</h2>

      <form onSubmit={handleSubmit} className="ro-panel">
        {/* Statement Date Selection */}
        <div className="ro-row">
          <label className="ro-label" htmlFor="statementDate">Statements</label>
          <div className="ro-field">
            <select
              id="statementDate"
              name="statementDate"
              value={formData.statementDate}
              onChange={handleChange}
              className="ro-select"
            >
              <option value="">Select a date</option>
              <option value="2026-07-31">Jul 31, 2026</option>
              <option value="2024-08-31">Aug 31, 2024</option>
              <option value="2024-08-29">Aug 29, 2024</option>
              <option value="2024-08-01">Aug 1, 2024</option>
              <option value="2024-07-31">Jul 31, 2024</option>
              <option value="2024-07-01">Jul 1, 2024</option>
              <option value="2024-06-29">Jun 29, 2024</option>
              <option value="2024-06-12">Jun 12, 2024</option>
              <option value="2024-06-07">Jun 7, 2024</option>
              <option value="2024-06-05">Jun 5, 2024</option>
              <option value="2024-05-31">May 31, 2024</option>
              <option value="2023-09-30">Sep 30, 2023</option>
            </select>
          </div>
        </div>

        {/* Account Tags Selection */}
        <div className="ro-row">
          <label className="ro-label" htmlFor="tags">Account Tags</label>
          <div className="ro-field">
            <select
              id="tags"
              name="tags"
              value={formData.tags}
              onChange={handleChange}
              className="ro-select"
            >
              <option value="">No filter</option>
              <option value="a-practices">a-practices</option>
              <option value="bhandal">bhandal</option>
              <option value="coventry-dental">coventry-dental</option>
              <option value="dental-beauty">dental-beauty</option>
              <option value="murray-dental-">murray-dental-</option>
              <option value="swissmeda">swissmeda</option>
            </select>
          </div>
        </div>

        {/* Accounts Checkbox */}
        <div className="ro-row">
          <span className="ro-label">Accounts</span>
          <div className="ro-field">
            <label className="ro-check" htmlFor="includeClosed">
              <input
                type="checkbox"
                id="includeClosed"
                name="includeClosed"
                checked={formData.includeClosed}
                onChange={handleChange}
              />
              Include estimations for accounts without a statement on this date
            </label>
          </div>
        </div>

        {/* Run Button */}
        <div className="ro-row ro-row-run">
          <Link to="/AddRevenue" className="ro-link">
            <button id="pay-per-task-submit" type="button" className="ro-run">
              <FaSearch /> Run
            </button>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ReportForm;